import { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";
import { Navigate } from "react-router-dom";
import { fetchClientObjectiveRoas } from "../api";
import { useDashboard } from "../context/DashboardContext";
import type { ClientObjectiveRoasRow } from "../types";

export function ClientObjectiveRoasPage() {
  const { session } = useDashboard();
  const [rows, setRows] = useState<ClientObjectiveRoasRow[] | null>(null);

  useEffect(() => {
    void fetchClientObjectiveRoas().then(setRows);
  }, []);

  if (session && !session.canViewObjectiveRoas) return <Navigate to="/" replace />;

  const declarados = rows?.filter((row) => row.objetivo_esta_declarado).length ?? 0;

  return (
    <div className="page">
      <section className="page-intro enter">
        <div>
          <span className="eyebrow">Privado · Dirección (Camilo y Joaquín)</span>
          <h1>Objetivos y ROAS por cliente</h1>
          <p>Objetivo declarado, portada correcta (costo por unidad del objetivo) y si ROAS aplica — cartera completa.</p>
        </div>
        {rows && <span className="count-badge">{declarados}/{rows.length} declarados</span>}
      </section>

      <section className="panel usage-table-panel">
        <div className="table-scroll">
          <table className="usage-table">
            <thead>
              <tr>
                <th>Cliente</th>
                <th>Objetivo declarado</th>
                <th>Portada correcta</th>
                <th>ROAS</th>
              </tr>
            </thead>
            <tbody>
              {rows?.map((row) => (
                <tr key={row.client_slug}>
                  <td className="primary-cell">{row.display_name ?? row.client_slug}</td>
                  <td className={row.objetivo_esta_declarado ? undefined : "accent-danger"}>
                    {row.objetivo_declarado}
                  </td>
                  <td>{row.portada_correcta ?? "—"}</td>
                  <td>{row.roas ?? "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {rows && rows.length === 0 && <p className="empty-table">Sin clientes activos.</p>}
          {!rows && (
            <p className="empty-table" style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" }}>
              <RefreshCw size={15} className="spin" />
              <span>Consultando objetivos en BigQuery…</span>
            </p>
          )}
        </div>
      </section>
    </div>
  );
}
